import MainContent from "@/pages/cv/detailCv/components/MainContent";
import SideContent from "@/pages/cv/detailCv/components/SideContent";
import { useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import CvService from "@/services/CvService";
import {LoadingComponent} from "@/components/ui/LoadingComponent";

const DetailCV = () => {
    const {id} = useParams();
    const [cv, setCv] = useState({});
    const [loading, setLoading] = useState(false);
    const [cvHot, setCvHot] = useState([]);

    useEffect(() => {
        CvService.getCvNoiBat().then((res => {
            setCvHot(res);
        })).catch((err) => {
            console.error(err)
        })
    },[])

    useEffect(() => {
        CvService.getDetailCv(id).then((res) => {
            setCv(res.Data);
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        })
    }, [id]);

if (loading) {
    return (
        <LoadingComponent/>
    )
}
    return (
        <div className={"justify-center flex flex-row gap-6 p-4 bg-gray-50 min-h-screen"}>
            <MainContent data={cv} />
            <SideContent data={cvHot}  />
        </div>
    )
}

export default DetailCV;